import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.p`
  padding: 0 16px;
  margin: 0;
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;

  @media screen and (min-width: ${DESKTOP}px) {
    margin: 0 auto;
    padding: 0;
    width: 900px;
    font-size: 46px;
  }
`;
